// The app-wide store singleton, as a dependency-free live binding. Runtime
// consumers (api/axios, sagas/WSNotifications) import { store } from here
// instead of from the src/index.js entry — importing the entry created a module
// cycle (index -> store -> sagas -> index) whose re-entrant evaluation under
// Vite's timestamped dev re-fetches called configureStore() while store/index.js
// was mid-evaluation (temporal dead zone), killing the app on HMR invalidations.
// This module deliberately imports NOTHING so it can never participate in a
// cycle; the entry assigns the store via initStore() at boot, before any
// consumer's runtime code can dispatch.
export let store;

export function initStore(configuredStore) {
  store = configuredStore;
}
